import { render } from "./CompleteFitOverlay.vue?vue&type=template&id=b063e96a&lang=pug"
import script from "./CompleteFitOverlay.vue?vue&type=script&lang=js"
export * from "./CompleteFitOverlay.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__